export const PROGRAM_MANAGER_L1 = "PROGRAM_MANAGER_L1";
export const PROGRAMS_DELETE = "PROGRAMS_DELETE";
export const PROGRAMS_ADD = "PROGRAMS_ADD";
export const PROGRAMS_SELECT = "PROGRAMS_SELECT";
export const PROGRAMS_UPDATE = "PROGRAMS_UPDATE";
export const DEVICE_DELETE_R100 = "DELETE_DEVICE_R100";
export const DEVICE_ADD = "DEVICE_ADD";
export const DEVICE_DELETE = "DEVICE_DELETE";
export const DEVICE_UPDATE = "DEVICE_UPDATE";
export const DEVICE_SELECT = "DEVICE_SELECT";
export const GROUPS_ADD = "GROUPS_ADD";
export const GROUPS_DELETE = "GROUPS_DELETE";
export const GROUPS_UPDATE = "GROUPS_UPDATE";
export const GROUPS_SELECT = "GROUPS_SELECT";
export const USERS_ADD = "USERS_ADD";
export const USERS_DELETE = "USERS_DELETE";
export const USERS_UPDATE = "USERS_UPDATE";
export const USERS_SELECT = "USERS_SELECT";

export const PROGRAM_MANAGER_L1_ID = "1162af87-cd83-4dc6-8110-4ab68d19de33";
export const PROGRAMS_DELETE_ID = "915c8c3c-849a-49e0-8032-ac4f9feb2956";
export const PROGRAMS_ADD_ID = "7fc44b6a-c81d-4423-beb9-ba92417ab865";
export const PROGRAMS_SELECT_ID = "f4a134d5-bbd7-4a49-95b2-72f6e1096f41";
export const PROGRAMS_UPDATE_ID = "7b309536-cf4c-47b3-8a97-71fe2f1a475e";
export const DEVICE_DELETE_R100_ID = "e461bd43-7679-4178-9123-0ae70f446a5e";
export const DEVICE_ADD_ID = "26c214da-3bf8-410e-a861-804ddfb814d9";
export const DEVICE_DELETE_ID = "c56a9c22-a08e-4a3f-af9b-e44aac23e9d5";
export const DEVICE_UPDATE_ID = "bfa60e51-d152-4a79-871c-b987bedbeb0b";
export const DEVICE_SELECT_ID = "65c38335-cbcc-42c7-8345-d0fa475ee80d";
export const GROUPS_ADD_ID = "5e1c5eed-9a80-40b4-b309-4548e431111b";
export const GROUPS_DELETE_ID = "acb1fa4b-d7fd-4bc1-af18-28faa80a0a32";
export const GROUPS_UPDATE_ID = "8700dabd-c6b1-479b-8624-939d3228fa9e";
export const GROUPS_SELECT_ID = "3a0c7025-5a5e-4d14-a5c6-c4b169cecee6";
export const USERS_ADD_ID = "b8957d72-3112-4334-b33a-417d58cb0bbd";
export const USERS_DELETE_ID = "cde9bd83-7d47-4630-9101-2cd1cc19dedc";
export const USERS_UPDATE_ID = "2a95508c-1386-4e55-9de2-184dfae12a3c";
export const USERS_SELECT_ID = "1bd22ce-bdff-46ad-9cd4-fd0d3166104b";

export const EMT_USER = "EMT_USER";
export const EMT_USER_ID = "43866ba5-329a-426d-a9a4-6f5b0f4ee1a8";
export const EMT_VIEWER = "EMT_VIEWER";
export const EMT_VIEWER_ID = "aa9ad2bd-6489-4ff2-bfb6-3f8914ae4e4f";
export const EMT_ADMIN = "EMT_ADMIN";
export const EMT_ADMIN_ID = "6beefcd7-995a-4b59-8498-c216a8951b66";
